import { ConditionAttribute, ConditionOperator } from 'shared/types/graphql';

export enum PatientAgeUnit {
  Years = 'Years',
  Months = 'Months',
}

export type SendConditionPatientAgeOperator =
  | ConditionOperator.Between
  | ConditionOperator.LessThan
  | ConditionOperator.GreaterThan;

interface SendConditionPatientAgeBase {
  createdAt: string;
  attribute: ConditionAttribute.PetAgeInYears;
}
interface SendConditionPatientAgeBetween extends SendConditionPatientAgeBase {
  operator: ConditionOperator.Between;
  operand: {
    value: { upper: number | null; lower: number | null };
    displayUnit?: PatientAgeUnit;
  };
}

export interface SendConditionPatientAgeLessGreaterThan extends SendConditionPatientAgeBase {
  operator: ConditionOperator.LessThan | ConditionOperator.GreaterThan;
  operand: {
    value: number | null;
    displayUnit?: PatientAgeUnit;
  };
}

export type SendConditionPatientAge = SendConditionPatientAgeLessGreaterThan | SendConditionPatientAgeBetween;
